export default {
  INITIATE_UN_SEALED: '您未加盖印章，无法发起签署',
  SIGN_UN_SEALED: '您未加盖印章，无法签署文件'
}
